import SetupContainer from './containers/SetupContainer';
import { connect } from 'react-redux';

import {
  storeNcesDistrictId,
  storeNcesSchoolId,
} from '../Registration/onboarding/onboarding.duck';

const mapDispatchToProps = dispatch => ({
  storeNcesDistrictId: ncesId => dispatch(storeNcesDistrictId(ncesId)),
  storeNcesSchoolId: ncesId => dispatch(storeNcesSchoolId(ncesId)),
});

const mapStateToProps = state => ({
  registrationId: state.user.registrationId,
  verifiedSchools: state.setupSchool.verifiedSchools,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetupContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/index.js